module.exports = __webpack_public_path__ + "media/about/max-volsky-8bf7e2ed.jpg";